import React, { useState } from 'react';

/** Extrae el id de YouTube de cualquier formato de URL */
function idDeYoutube(url) {
  if (!url) return null;
  const m = String(url).match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
}

const IconPlay = () => (
  <svg viewBox="0 0 68 48" width="68" height="48" aria-hidden="true">
    <path d="M66.5 7.7a8.3 8.3 0 0 0-5.8-5.9C55.5.5 34 .5 34 .5s-21.5 0-26.7 1.3A8.3 8.3 0 0 0 1.5 7.7 87 87 0 0 0 .2 24a87 87 0 0 0 1.3 16.3 8.3 8.3 0 0 0 5.8 5.9C12.5 47.5 34 47.5 34 47.5s21.5 0 26.7-1.3a8.3 8.3 0 0 0 5.8-5.9A87 87 0 0 0 67.8 24a87 87 0 0 0-1.3-16.3z" fill="#f00"/>
    <path d="M27.2 34.3 44.9 24 27.2 13.7z" fill="#fff"/>
  </svg>
);

/**
 * Muestra el video del curso o material.
 * Carga solo la miniatura; el iframe de YouTube entra al hacer clic,
 * así la página no arrastra el peso del reproductor de entrada.
 */
export default function VideoCurso({ url, titulo }) {
  const [activo, setActivo] = useState(false);
  const id = idDeYoutube(url);

  if (!id) return null;

  return (
    <div style={{
      position:'relative', width:'100%', aspectRatio:'16/9',
      borderRadius:16, overflow:'hidden', background:'#111614',
      marginBottom:'1.5rem',
    }}>
      {activo ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`}
          title={titulo || 'Video'}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ position:'absolute', inset:0, width:'100%', height:'100%', border:0 }}
        />
      ) : (
        <button
          onClick={() => setActivo(true)}
          aria-label={`Reproducir video${titulo ? ': ' + titulo : ''}`}
          style={{
            position:'absolute', inset:0, width:'100%', height:'100%',
            border:'none', padding:0, cursor:'pointer',
            backgroundImage:`url(https://img.youtube.com/vi/${id}/maxresdefault.jpg)`,
            backgroundSize:'cover', backgroundPosition:'center',
            display:'flex', alignItems:'center', justifyContent:'center',
          }}>
          <span style={{
            position:'absolute', inset:0,
            background:'linear-gradient(180deg, rgba(0,0,0,.05), rgba(0,0,0,.25))',
          }}/>
          <span style={{ position:'relative', filter:'drop-shadow(0 4px 14px rgba(0,0,0,.35))' }}>
            <IconPlay/>
          </span>
        </button>
      )}
    </div>
  );
}